import { TabPane } from "reactstrap";

export default function TabPanel() {
  return null
}
